import {ProductPrice} from "../../api/models";
import {formatPrice} from "../../components/format";

export function ProductPrices({prices}: { prices: ProductPrice[] }) {
    if (prices.length === 0) {
        return null;
    }
    return (
        <ul className="list-unstyled mb-0">
            {prices.map(x => (
                <li key={`${x.edition}|${x.currency}`}>
                    <span className="text-body-secondary">{x.edition}</span> <strong>{formatPrice(x.amount, x.currency)}</strong>
                </li>
            ))}
        </ul>
    );
}
